import { render, staticRenderFns } from "./EModalSelectMonthAula.vue?vue&type=template&id=d06368a4&scoped=true"
import script from "./EModalSelectMonthAula.vue?vue&type=script&lang=js"
export * from "./EModalSelectMonthAula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06368a4",
  null
  
)

export default component.exports